import * as ActionType from '../quickbet';
import { addRateCoupon } from './coupon';
import Immutable from "immutable";
export function openQuickbetModal() {
    return { type: ActionType.OPEN_QUICKBET_MODAL };
}
export function closeQuickbetModal() {
    return { type: ActionType.CLOSE_QUICKBET_MODAL };
}
export function addRate(data) {
    return { type: ActionType.ADD_QUICKBET_RATE, data: data };
}
export function acceptChange() {
    return { type: ActionType.ACCEPT_QUICKBET_FACTOR_CHANGE };
}
export function addQuickBetRate(data) {
    return function (dispatch, getState) {
        var couponBetSlips = getState().coupon.get('betSlips');
        var bettingMode = getState().application.get('bettingMode');
        if (couponBetSlips.size > 0 && !bettingMode.isOneClickOn) {
            return dispatch(addRateCoupon(addRateToCoupon(data, couponBetSlips)));
        }
        dispatch(openQuickbetModal());
        return dispatch(addRate(data));
    };
}
function addRateToCoupon(addRate, couponBetSlips) {
    var match = addRate.match;
    var outcome = addRate.outcome;
    var rate = addRate.rate;
    return Immutable.fromJS({
        betNum: couponBetSlips.size,
        rate: rate,
        outcome: {
            name: outcome.get('name')
        },
        match: {
            name: match.get('name'),
            timeAndZone: match.get('timeAndZone'),
            notice: match.get('notice')
        }
    });
}



// WEBPACK FOOTER //
// ./src/actions/coupon/creators/quickbet.js